<template>
  <section class="news-article">
    <div v-if="cardType" class="card" @click="clickNaverArticle(item.link)">
      <img loading="lazy" class="card-thumbnail" :src="item.image" />
      <div>
        <div class="card-title">{{ item.title }}</div>
        <div v-if="existPressData" class="press">
          <img loading="lazy" :src="item.press.image" class="press-avatar" />
          <span class="press-name">{{ item.press.name }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="article-layer" @click="issueLink(item.link)">
        <img loading="lazy" :src="item.image" />
        <div class="article">
          <div class="article-rank">인기 {{ index + 1 }}위</div>
          <div class="article-title" v-html="item.title"></div>
          <div v-if="item.desc.length" class="article-description" v-html="item.desc"></div>
          <div v-if="existPressData" class="press">
            <img loading="lazy" :src="item.press.image" class="press-avatar" />
            <span class="press-name">{{ item.press.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["index", "item", "hideRanking", "cardType"],
  computed: {
    existPressData() {
      return this.item?.press != null
    }
  },
  data() {
    return {
      isMobile: true
    }
  },
  created() {
    this.onResize()
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 586
    },
    link(url) {
      window.open(url)
    },
    clickNaverArticle(url) {
      gtag("event", "click-naver-article")
      this.link(url)
    },
    issueLink(url) {
      const rank = this.index + 1
      gtag("event", "click-issue-rank", {
        value: rank
      })
      this.link(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixin.scss";
.news-article {
  .article-keyword {
    @include small-mobile {
      font-size: 14px;
    }
    @include mobile {
      font-size: 16px;
    }
  }

  .article-layer {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 15px 0;
    border-bottom: 1px solid #efefef;
    .article-rank {
      color: #77b6b1;
      font-weight: bold;
      font-size: 14px;
      margin-top: -5px;
    }
    .article-title {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 1.25;
      margin-top: 5px;
      @include tablet {
        margin-top: 10px;
      }
    }
    .article-description {
      display: none;
      @include tablet {
        margin-top: 5px;
        font-size: 14px;
        color: #767678;
        line-height: 1.25;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    & > img {
      position: relative;
      object-fit: cover;
      margin-right: 10px;
      border-radius: 4px;
      min-width: 130px;
      width: 130px;
      min-height: 85px;
      height: 85px;

      @include small-mobile {
        min-width: 120px;
        width: 120px;
        min-height: 80px;
        height: 80px;
      }

      @include tablet {
        min-width: 200px;
        width: 200px;
        min-height: 120px;
        height: 120px;
      }
    }
  }
  .press {
    display: flex;
    align-items: center;
    margin-top: 5px;
    .press-avatar {
      vertical-align: middle;
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

    .press-name {
      margin-left: 5px;
      font-size: 14px;
      color: #606060;
    }
  }
  .card {
    border-radius: 10px;
    cursor: pointer;
    margin: 5px;
    background: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    &-thumbnail {
      object-fit: cover;
      width: 100%;
      height: 100px;
    }
    &-title {
      height: 34px;
      color: white;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      padding: 0 5px;
      line-height: 1.25;
    }
    .press {
      padding: 5px;
      border-top: 1px solid #909090;
      .press-name {
        color: #c0c0c0;
      }
    }
  }
}
</style>
